import React from "react";

// Local Libraries
import phrasebookLoad from "../../../../i18n";
import { Form } from "../../../../components/SkyFramework/Forms";
import { ButtonBack } from "../../../../components/SkyFramework/ProgressTab/ButtonBack";
import { ButtonNext } from "../../../../components/SkyFramework/ProgressTab/ButtonNext";


// Constants
const phrasebook = phrasebookLoad();

var currencies = [{ value: 'USD', label: 'USD' }, { value: 'EUR', label: 'EUR' }, { value: 'GBP', label: 'GBP' }, { value: 'HKD', label: 'HKD' }, { value: 'CNY', label: 'CNY' }, { value: 'SGD', label: 'SGD' }];

export default class AddOrderForm extends React.Component {
  continue = (e) => {
    e.preventDefault();
    this.props.nextStep();
  };

  //

  render() {
    const { selectedTypeNumber, portingTypes, handleChange, nextStep, prevStep, actualState, accountLogged } = this.props;
    // This will be the form to input data for order return

    const translationNumberFormats = [{ value: 'e.164', label: phrasebook.orders.e164 }, { value: 'e.164+', label: phrasebook.orders.e164_plus }, { value: 'e.164prefix', label: phrasebook.orders.e164_prefix }, { value: 'e.164prefix+', label: phrasebook.orders.e164_prefix_plus }, { value: 'numberrange', label: phrasebook.orders.numberrange }, { value: 'individual', label: phrasebook.orders.individual }];
    let inputs = [
      { label: phrasebook.orders.order_details, type: "section" },
      [{ label: phrasebook.orders.number_quantity, type: "text", placeholder: actualState.number_quantity, id: "number_quantity", name: "number_quantity", value: actualState.number_quantity, tooltip: phrasebook.tooltip.number_quantity, required: true }],

      { label: phrasebook.orders.translation_number, type: "section" },
      { label: `${phrasebook.common.customer} ${phrasebook.references.reference}`, type: "text", id: "reference", name: "reference", value: actualState.reference, tooltip: phrasebook.tooltip.customer_reference, required: true },

      { label: phrasebook.numbers.additional_remarks, type: "textarea", id: "additional_remarks", name: "additional_remarks", value: actualState.additional_remarks },
    ]

    if (['SIP Trunking', 'DID'].includes(selectedTypeNumber.service_type)) {
      inputs.splice(3, 0, { label: phrasebook.numbers.translation_of_numbers, type: "text", value: phrasebook.numbers.translation1to1, disabled: true })
    } else inputs.splice(3, 0, { label: phrasebook.numbers.translation_of_numbers, type: "text", value: phrasebook.numbers.translation1tomany, disabled: true })

    inputs.splice(4, 0, [{ label: phrasebook.orders.translation_number_formats, type: "select", id: "translation_number_format", name: "translation_number_format", options: translationNumberFormats, selected: actualState.translation_number_format, tooltip: phrasebook.tooltip.translation_number_formats }]);


    if (['e.164prefix', 'e.164prefix+'].includes(actualState.translation_number_format)) {
      inputs[4].push({ label: phrasebook.orders.translation_number_prefix, type: "text", placeholder: actualState.translation_number_prefix, id: "translation_number_prefix", name: "translation_number_prefix", value: actualState.translation_number_prefix })
    }

    if (selectedTypeNumber.portability) inputs.splice(2, 0, { label: phrasebook.orders.porting_required, type: "checkbox", id: "porting", name: "porting", value: actualState.porting })


    if (selectedTypeNumber.service_type === 'SIP Trunking') {
      inputs[1].push({ label: phrasebook.orders.channel_quantity, type: "text", placeholder: actualState.channel_quantity, id: "channel_quantity", name: "channel_quantity", value: actualState.channel_quantity, tooltip: phrasebook.tooltip.channel_quantity });
    }

    if ([100, 110, 120].includes(accountLogged)) {
      inputs.push({ label: phrasebook.orders.add_custom_pricing, type: "checkbox", id: "add_custom", name: "add_custom", value: actualState.add_custom })
      if (actualState.add_custom) {
        inputs.push({ label: phrasebook.orders.custom_pricing, type: "section" }, { label: phrasebook.references.currency, type: "select", id: "custom_currency", name: "currency", options: currencies, selected: actualState.custom_tariff.currency, tooltip: phrasebook.tooltip.currency }, [{ label: phrasebook.pricing.nrc, type: "text", placeholder: actualState.custom_tariff.nrc, id: "custom_nrc", name: "nrc", value: actualState.custom_tariff.nrc, tooltip: phrasebook.tooltip.nrc },
        { label: phrasebook.pricing.mrc, type: "text", placeholder: actualState.custom_tariff.nrc, id: "custom_mrc", name: "mrc", value: actualState.custom_tariff.mrc, tooltip: phrasebook.tooltip.mrc }])
        if (selectedTypeNumber.service_type === 'ITFS' || selectedTypeNumber.service_type === 'UIFN') {

          let index = inputs.findIndex(p => Array.isArray(p) && p.find(k => k.id === "custom_mrc"));

          inputs.splice((index + 1), 0, { label: phrasebook.pricing.per_minute_rate, type: "subsection" });
          inputs.splice((index + 2), 0, [{ label: phrasebook.pricing.fix_usage_rate, type: "text", placeholder: actualState.custom_tariff.fix_usage_rate, id: "custom_fix_usage_rate", name: "fix_usage_rate", value: actualState.custom_tariff.fix_usage_rate }, { label: phrasebook.pricing.mobile_usage_rate, type: "text", placeholder: actualState.custom_tariff.mobile_usage_rate, id: "custom_mobile_usage_rate", name: "mobile_usage_rate", value: actualState.custom_tariff.mobile_usage_rate }, { label: phrasebook.pricing.payphone_usage_rate, type: "text", placeholder: actualState.custom_tariff.payphone_usage_rate, id: "custom_payphone_usage_rate", name: "payphone_usage_rate", value: actualState.custom_tariff.payphone_usage_rate }])
        }





        if (selectedTypeNumber.service_type === 'SIP Trunking') {
          var index = inputs.findIndex(p => Array.isArray(p) && p.find(k => k.id === "custom_mrc"));

          inputs.splice((index + 1), 0, { label: phrasebook.pricing.per_channel_charges, type: "subsection" });
          inputs.splice((index + 2), 0,
            [{ label: phrasebook.pricing.nrc_channel_charges, type: "text", placeholder: actualState.custom_tariff.nrc_channel_charges, id: "custom_nrc_channel_charges", name: "nrc_channel_charges", value: actualState.custom_tariff.nrc_channel_charges, tooltip: phrasebook.tooltip.nrc_channel_charges }, { label: phrasebook.pricing.mrc_channel_charges, type: "text", placeholder: actualState.custom_tariff.mrc_channel_charges, id: "custom_mrc_channel_charges", name: "mrc_channel_charges", value: actualState.custom_tariff.mrc_channel_charges, tooltip: phrasebook.tooltip.mrc_channel_charges }]);


          inputs.splice((index + 3), 0, { label: phrasebook.pricing.outbound_charges, type: "subsection" });
          inputs.splice((index + 4), 0, [{ label: phrasebook.pricing.outbound_charges_fixed, type: "text", placeholder: actualState.outbound_charges_fixed, id: "custom_outbound_charges_fixed", name: "outbound_charges_fixed", value: actualState.custom_tariff.outbound_charges_fixed, tooltip: phrasebook.tooltip.outbound_charges_fixed }, { label: phrasebook.pricing.outbound_charges_mobile, type: "text", placeholder: actualState.custom_tariff.outbound_charges_mobile, id: "outbound_charges_mobile", name: "custom_outbound_charges_mobile", value: actualState.custom_tariff.outbound_charges_mobile, tooltip: phrasebook.tooltip.outbound_charges_mobile }, { label: phrasebook.pricing.outbound_charges_special, type: "text", placeholder: actualState.custom_tariff.outbound_charges_special, id: "custom_outbound_charges_special", name: "outbound_charges_special", value: actualState.custom_tariff.outbound_charges_special, tooltip: phrasebook.tooltip.outbound_charges_special }]);

        }
        if (['SIP Trunking', 'DID'].includes(selectedTypeNumber.service_type)) {
          var index = inputs.findIndex(p => Array.isArray(p) && p.find(k => k.id === "custom_mrc"));
          inputs.splice((index + 1), 0, { label: phrasebook.pricing.inbound_charges_per_minute, type: "subsection" });
          inputs.splice((index + 2), 0, { label: phrasebook.pricing.inbound_charges, type: "text", placeholder: actualState.custom_tariff.inbound_charges, id: "custom_inbound_charges", name: "inbound_charges", value: actualState.custom_tariff.inbound_charges },);
        }
      }

    }



    const buttons = [<ButtonBack title={phrasebook.common.previous} prevStep={prevStep} />, <ButtonNext title={phrasebook.common.next} nextStep={nextStep} />]

    return (<Form
      handleSubmit={undefined}
      onChange={handleChange}
      title={phrasebook.orders.add_to_order}
      inputs={inputs}
      buttons={buttons}
    />
    );
  }
}
